import {getRumGlobal} from '../utils'
import type {RumEventAdditional, RumEventName, RumEventValue} from './types'

export const logEvent = (name: RumEventName, value: RumEventValue = '', additional?: RumEventAdditional) => {
  const {logEventFloat, logEventInteger, logEventString} = getRumGlobal() || {}
  const logEventNumber = Number.isInteger(value) ? logEventInteger : logEventFloat

  return typeof value === 'string'
    ? logEventString?.(name, value, {additional})
    : logEventNumber?.(name, value, {additional})
}
